import axios from "axios";
import React, { useEffect, useState } from "react";
import Share from "../../../../../../Assets/Icon/share.png";
import ShareB from "../../../../../../Assets/Icon/ShareB.png";
import SharePost from "../../../../../../Screen/SharePost";

const FanPostReaction = ({ post }) => {
  const parseId = parseInt(localStorage.getItem("auth_id"));
  const [isShare, setIsShare] = useState(false);
  const [likerId, setLikerId] = useState();
  const [isLiked, setIsLiked] = useState();
  const [likeCount, setLikeCount] = useState();

  const [shareCount, setShareCount] = useState();

  function handlePost(data, postId) {
    if (data.includes(parseId) === true) {
      const checked_data = data.filter((item) => item !== parseId);
      handleChange(checked_data, postId);
    } else {
      handleChange([...data, parseId], postId);
    }
  }

  const moveData = (data) => {
    setShareCount(Number(Number(shareCount) + Number(data)));
  };

  function handleClick(postId, action) {
    if (action == 1) {
      setLikeCount(likeCount + 1);
      setIsLiked(true);
    } else {
      setLikeCount(likeCount - 1);
      setIsLiked(false);
    }

    handlePost(likerId, postId);
  }

  function handleChange(data, postId) {
    const formData = new FormData();
    setLikerId(data);

    formData.append("showlike", JSON.stringify(data));

    axios
      .post(`/api/user/fan/group/post/like/${postId}`, formData)
      .then((res) => {
        if (res.status === 200) {
        }
      });
  }

  useEffect(() => {
    setLikerId(JSON.parse(post?.user_like_id));
    setShareCount(parseInt(post?.share_count));
    JSON.parse(post?.user_like_id).includes(parseId)
      ? setIsLiked(true)
      : setIsLiked(false);
    setLikeCount(JSON.parse(post?.user_like_id).length);
  }, [post, parseId]);

  return (
    <>
      <div className="d-flex justify-content-between PostGV">
        <div className="col-md-6">
          <li className="like-post">
            {likeCount === 0 ? null : (
              <>
                <i className="fas fa-heart heart mx-1 "></i>
                <small className="profile-card-text">{likeCount}</small>
              </>
            )}
          </li>
        </div>
        <div className="col-md-6">
          <li className="share-post">
            {shareCount === 0 ? null : (
              <>
                <img src={Share} alt="" width="15" /> &nbsp;
                <small className="profile-card-text">{shareCount} Shares</small>
              </>
            )}
          </li>
        </div>
      </div>
      <div className=" LikedBg px-4">
        <div className="di">
          {isLiked ? (
            <button
              className="BtnD py-2 border-0"
              onClick={() => handleClick(post.id, 0)}
            >
              <i className="fas fa-heart mx-1 text-danger"></i>
              <small className="Post-Title-home"> Loved </small>
            </button>
          ) : (
            <button
              className="BtnD py-2 border-0"
              onClick={() => handleClick(post.id, 1)}
            >
              <i className="fas fa-heart mx-1 text-light"></i>
              <small className="Post-Title-home"> Love </small>
            </button>
          )}
        </div>
        <div className="di">
          <button
            className="BtnD py-2 border-0"
            onClick={() => {
              setIsShare(!isShare);
            }}
          >
            <img src={ShareB} width="20" alt="" />
            &nbsp;
            <small className="Post-Title-home"> Share</small>
          </button>
          {isShare ? (
            <div className="sharePostMainDiv">
              <SharePost
                postId={post.id}
                type="fanpostshare"
                onMoveData={moveData}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>

      {/* <ul className="mx-4 PostGV mt-1 ">
        <li className="like-post">
          <i className="fas fa-heart heart mx-1 "></i>&nbsp;
          <small className="profile-card-text">{likeCount}</small>
        </li>
        <li className="share-post">
          <img src={Share} alt="" width="15" /> &nbsp;
          <small className="profile-card-text">{shareCount} Share</small>
        </li>
      </ul>

      <div className=" LikedBg px-4">
        <div className="di">
          {isLiked ? (
            <button
              className="BtnD py-2 border-0"
              onClick={() => handleClick(post.id, 0)}
            >
              <i className="fas fa-heart mx-1 text-danger"></i>
              <small className="Post-Title-home"> Loved </small>
            </button>
          ) : (
            <button
              className="BtnD py-2 border-0"
              onClick={() => handleClick(post.id, 1)}
            >
              <i className="fas fa-heart mx-1 text-light"></i>
              <small className="Post-Title-home"> Love </small>
            </button>
          )}
        </div>
        <div className="di">
          <button
            className="BtnD py-2 border-0"
            onClick={() => {
              setIsShare(!isShare);
            }}
          >
            <img src={ShareB} width="20" alt="" />
            &nbsp;
            <small className="Post-Title-home"> Share</small>
          </button>
          {isShare ? (
            <div className="sharePostMainDiv">
              <SharePost
                postId={post.id}
                type="fanpostshare"
                onMoveData={moveData}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div> */}
    </>
  );
};

export default FanPostReaction;
